import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addtable',
  templateUrl: './addtable.component.html',
  styleUrls: ['./addtable.component.css']
})
export class AddtableComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  tablesectionColl: any = [];
  //Edit Get Values
  tableColl: any = [];
  tableid: number = 0

  tableform = new FormGroup({
    tableid: new FormControl(0),
    tableno: new FormControl('', Validators.required),
    tablesectionid: new FormControl(null, Validators.required),
    noofpeople: new FormControl(null),
    tableorderno: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Table";


  @Input() tablename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.tableid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.tableform.reset();
      this.fnInitializeTable();

      if (this.tableid > 0) {
        this.fngetTable();
      }
      this.fngetTableSection();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.tableid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeTable() {
    this.tableform.setValue({

      tableid: 0,
      tableno: '',
      tablesectionid: null,
      noofpeople:null,
      tableorderno:null,
      inactive: false,
    })
  }
  //Get 
  fngetTableSection() {

    var data = {
      'tablesectionid':0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getTableSection(data)
      .subscribe(
        (res) => {
          this.tablesectionColl = res.json().result;
       
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetTable() {

    var data = {
      'tableid': this.tableid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getTable(data)
      .subscribe(
        (res) => {
          this.tableColl = res.json().result;
          var editdata = this.tableColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.tableform.valid) {
        //Check
        this.saveloading=true;

        var data = {
          'tableid': this.tableid,
          'tableno': this.tableform.get('tableno').value,
          'tablesectionid': this.tableform.get('tablesectionid').value,
          'noofpeople':this.fnGetIntValues(this.tableform.get('noofpeople').value),
          'tableorderno': this.tableform.get('tableorderno').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.tableform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckTable(data).subscribe(
          (res) => {

            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.tableform.get('tableid').value > 0) {
                //Update Department
                this.fnSetTable(data);
              }
              else {
                //Insert Department
                this.fnInsertTable(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false;

                this.tableform.controls['tableno'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertTable(data) {

    this.appService.fnInsertTable(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().result != "") {
          this.toastr.success('', "The New Table has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.tableid);

          this.emitData.emit(this.tableid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetTable(data) {

    this.appService.fnSetTable(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().result != "") {
          this.toastr.success('', "The Table has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.tableid, data.table);

          this.emitData.emit(this.tableid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.tableform.setValue({

      tableid: deptBO.tableid,
      tableno: deptBO.tableno,
      tablesectionid: deptBO.tablesectionid,
      tableorderno: deptBO.tableorderno,
      noofpeople: deptBO.noofpeople,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }


  fnGetIntValues(value) {
  
    if (value === '') {
      return null
    }
    else {
      return value
    }

  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
